(function () {
    'use strict';

    angular.module('BaseCMSApp', []).controller('zoneController', zoneController);

    /** @ngInject */
    function zoneController($scope, $http, $timeout) {
        $scope.province_id = 0;
        $scope.provinces = [];

        $scope.district_id = 0;
        $scope.districts = [];

        $scope.township_id = 0;
        $scope.townships = [];

        $scope.address = '';
        $scope.full_address = '';

        $http.get(basePath + '/ajax/provinces', {
            cache: true
        }).success(function(data){
            data = _.map(data, function(d){
                d.id = Number(d.id);
                return d;
            });

            $scope.provinces = data;
            if (! _.find($scope.provinces, {id: $scope.province_id})){
                $scope.province_id = 0;
            }
        });

        $scope.$watch('province_id', function(){
            $http.get(basePath + '/ajax/districts', {
                params: {
                    id: $scope.province_id
                },
                cache: true
            }).success(function(data){
                data = _.map(data, function(d){
                    d.id = Number(d.id);
                    return d;
                });

                $scope.districts = data;
                if (! _.find($scope.districts, {id: $scope.district_id})){
                    $scope.district_id = 0;
                }

                updateAddress();
            });
        });

        $scope.$watch('district_id', function(){
            $http.get(basePath + '/ajax/townships', {
                params: {
                    id: $scope.district_id
                },
                cache: true
            }).success(function(data){
                data = _.map(data, function(d){
                    d.id = Number(d.id);
                    return d;
                });

                $scope.townships = data;
                if (! _.find($scope.townships, {id: $scope.township_id})){
                    $scope.township_id = 0;
                }

                updateAddress();
            });
        });

        $scope.$watch('township_id', function(){
            updateAddress();
        });

        $scope.$watch('address', function(){
            updateAddress();
        });

        var updateAddress = function () {
            var province = '',
                district = '',
                township = '',
                address = '',
                f_province, f_district, f_township;

            f_province = _.find($scope.provinces, {id: $scope.province_id});
            if (f_province && $scope.province_id) {
                province = f_province.name;
            }

            f_district = _.find($scope.districts, {id: $scope.district_id});
            if (f_district && $scope.district_id) {
                district = f_district.name + ', ';
            }

            f_township = _.find($scope.townships, {id: $scope.township_id});
            if (f_township && $scope.township_id) {
                township = f_township.name + ', ';
            }

            if ($scope.address) {
                address = $scope.address + ', ';
            }

            $scope.full_address = address + township + district + province;

            $timeout(function(){
                $('.bs-select-search-angular:not(.select2-container)').select2({
                    allowClear: true
                });
            });
        };
    }
})();